import i18next from 'i18next';
import { isEmpty, isNull } from 'lodash';

import { TEMPLATE_TYPES } from 'common/constants';

import { PDF_MEDIUM_QUALITY, XLS_FILE } from './constants';

export const getDownloadOptions = () => {
    return [
        {
            disabled: true,
            label: i18next.t('Select format'),
            value: '',
        },
        {
            label: `PDF - ${i18next.t('File')}`,
            value: PDF_MEDIUM_QUALITY,
        },
        {
            label: `XLS - ${i18next.t('File')}`,
            value: XLS_FILE,
        },
    ];
};

export const getFileNameFromURL = (archive) => {
    if (!isNull(archive))
        return archive.substring(archive.lastIndexOf('/') + 1);
    return '';
};

export const getIsDownloadingFileContextMessage = (
    isDownloading,
    loadingContext,
) => {
    if (isEmpty(loadingContext)) return;
    if (isDownloading)
        loadingContext.openLoading(i18next.t('Downloading').concat('...'));
    else loadingContext.closeLoading();
};

export const getIsLoadingContextMessage = ({
    isFetchingProposalDetails,
    isFetchingProposalContent,
    isInitializing,
    loadingContext,
}) => {
    if (isEmpty(loadingContext)) return;
    if (
        isFetchingProposalDetails ||
        isFetchingProposalContent ||
        isInitializing
    )
        loadingContext.openLoading(i18next.t('Loading').concat('...'));
    else loadingContext.closeLoading();
};

export const getIsUpdatingContextMessage = (
    editionDisabled,
    isUpdatingCustomTemplate,
    loadingContext,
    setEditionDisabled,
) => {
    if (isEmpty(loadingContext)) return;
    if (isUpdatingCustomTemplate)
        loadingContext.openLoading(i18next.t('Saving'.concat('...')));
    else {
        if (!editionDisabled) setEditionDisabled(true);
        loadingContext.closeLoading();
    }
};

export const handleCloseDrawer = (swipeableDrawerRef) => {
    if (swipeableDrawerRef.current) {
        const { handleOpen } = swipeableDrawerRef.current;
        handleOpen(false);
    }
};

export const handleClickDocumentItemBuild = (
    document,
    fetchProposalContent,
    initTemplate,
    resetTemplate,
    selectedDocument,
    setDownloadFormat,
    setSelectedDocument,
    swipeableDrawerRef,
) => {
    const { contentId = null, id } = document;
    if (id !== selectedDocument.id) {
        resetTemplate();
        if (contentId) fetchProposalContent(contentId, initTemplate);
        setSelectedDocument(document);
        setDownloadFormat(PDF_MEDIUM_QUALITY);
    }
    handleCloseDrawer(swipeableDrawerRef);
};

export const handleClickDownloadBuild = (
    downloadDocumentPdf,
    downloadProposalPdf,
    downloadFormat,
    loadingContext,
    selectedDocument,
) => {
    const { archive, contentId, name, type } = selectedDocument;
    switch (type) {
        case TEMPLATE_TYPES.PDF_TYPE:
            return downloadDocumentPdf(archive, loadingContext, name);
        default:
            switch (downloadFormat) {
                case PDF_MEDIUM_QUALITY:
                    return downloadProposalPdf(contentId, downloadFormat, name);
                case XLS_FILE:
                    return () => {};
                default:
                    return () => {};
            }
    }
};

export const handleScrollTopSideBar = (sideBarRef) => {
    if (sideBarRef && sideBarRef.current) sideBarRef.current.scrollTop = 0;
};

export const getDocumentItemSx = (theme) => ({
    borderRadius: '8px',
    mb: '5px',
    '&.Mui-selected': {
        backgroundColor:
            theme.palette.mode === 'dark' ? '#000' : 'rgba(31, 60, 83, 0.13)',
        fontWeight: 'bold',
    },
    '& .MuiListItemText-primary': {
        fontSize: '0.875rem',
    },
});
